<template>
  <v-data-table
    :headers="headers"
    :items="users"
    :search="search"
    sort-by="username"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>User Management</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <!-- <v-btn color="primary" dark class="mb-2" v-on="on">New User</v-btn>-->
            <v-btn class="mx-2" fab small dark color="indigo" v-on="on">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    v-for="header in headers"
                    :key="header.value"
                  >
                    <v-text-field
                      v-if="
                        (header.value != 'action') &
                          (header.type != 'select') &
                          (header.type != 'password') &
                          (header.type != 'selectDept') &
                          (header.type != 'selectApp') &
                          (header.type != 'selectClinic')
                      "
                      v-model="editedItem[header.value]"
                      :label="header.text"
                    ></v-text-field>
                    <v-text-field
                      v-if="header.type == 'password'"
                      v-model="password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      hint="At least 6 characters"
                      @click:append="show1 = !show1"
                    ></v-text-field>
                    <v-select
                      v-if="header.type === 'select'"
                      :items="user_groups"
                      v-model="editedItem[header.id]"
                      item-text="name"
                      item-value="id"
                      auto-select-first
                      :label="header.text"
                    ></v-select>
                    <v-autocomplete
                      v-if="header.type === 'selectDept'"
                      :items="departments"
                      v-model="editedItem[header.id]"
                      item-text="dept_code"
                      item-value="dept_id"
                      :label="header.text"
                      v-on:change="toggleClinicSelect(editedItem[header.id])"
                      auto-select-first
                      return-object
                    ></v-autocomplete>
                    <v-autocomplete
                      v-if="
                        (header.type === 'selectClinic') & !hide_clinic_select
                      "
                      :items="clinics"
                      v-model="editedItem[header.id]"
                      item-text="name"
                      item-value="ref_number"
                      :label="header.text"
                      auto-select-first
                    ></v-autocomplete>
                    <v-autocomplete
                      v-if="header.type === 'selectApp'"
                      :items="apps"
                      v-model="editedItem[header.id]"
                      item-text="app_name"
                      item-value="app_no"
                      :label="header.text"
                      auto-select-first
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mdi mdi-border-color"
        @click="editItem(item)"
      ></v-icon>
      <v-icon small class="mdi mdi-delete" @click="deleteItem(item)"></v-icon>
    </template>
    <template v-slot:item.status="{ item }">
      <v-icon v-if="item.status === 1" small class="mdi mdi-check"></v-icon>
      <v-icon v-if="item.status === 0" small class="mdi mdi-close"></v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
    <template v-slot:item.password="{ item }">
      <v-btn
        icon
        class="grey lighten-4 mx-2"
        @click="resetPassword({ name: 'reset_password', item: item })"
      >
        <reset-password
          :props_userID="selected_user_id"
          :props_userName="selected_user_name"
        />
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import { mapState, createNamespacedHelpers } from "vuex";
import moment from "moment";
const resetPassword = () => import("./users/dialog-reset-password.vue");
const appsNamespace = createNamespacedHelpers("apps");
const clinicsNamespace = createNamespacedHelpers("clinics");

export default {
  name: "UserDataTable",
  components: {
    resetPassword
  },
  data: () => ({
    dialog: false,
    show: false,
    show1: false,
    password: null,
    selected_user_id: null,
    selected_user_name: null,
    is_toggled: null,
    search: "",
    headers: [
      {
        text: "First Name",
        align: "left",
        sortable: false,
        value: "firstname"
      },
      { text: "Last Name", value: "lastname" },
      { text: "User Name", value: "username" },
      {
        text: "Password",
        value: "password",
        hidden: true,
        sortable: false,
        type: "password"
      },
      // { text: "Email Address", value: "email" },
      {
        text: "Security Group",
        value: "group_name",
        id: "group_id",
        type: "select"
      },
      {
        text: "Department",
        value: "dept_code",
        id: "dept_id",
        type: "selectDept"
      },

      {
        text: "Clinic",
        value: "clinic_id",
        id: "clinic_id",
        type: "selectClinic"
      },
      {
        text: "App",
        value: "app_id",
        id: "app_id",
        type: "selectApp"
      },
      { text: "Active Status", value: "status", toggled: true },
      { text: "Actions", value: "action", sortable: false }
    ],
    //users: [],
    departments: [],
    user_groups: [],
    editedIndex: -1,
    hide_clinic_select: true,
    current_date: moment().format("YYYY-MM-DD"),
    editedItem: {
      firstname: "",
      lastname: "",
      username: "",
      password: "",
      email: "",
      group_id: "",
      dept_id: "",
      app_id: "",
      clinic_id: "",
      status: ""
    },
    defaultItem: {
      firstname: "",
      lastname: "",
      username: "",
      password: "",
      email: "",
      group_id: "",
      dept_id: "",
      app_id: "",
      clinic_id: "",
      status: ""
    }
  }),

  computed: {
    ...mapState({
      users: state => state.users.users
    }),
    ...appsNamespace.mapState({ apps: state => state.apps }),
    ...clinicsNamespace.mapState({ clinics: state => state.clinics }),
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();

      if (val) {
        this.$store.dispatch("user_groups/fetchUserGroups").then(res => {
          this.user_groups = res;
        });

        this.$store.dispatch("department/fetchDepartments").then(res => {
          this.departments = res;
        });

        this.afetchApps();
      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...appsNamespace.mapActions(["afetchApps"]),
    ...clinicsNamespace.mapActions(["afetchClinics"]),
    initialize() {
      this.$store.dispatch("users/fetchUsers");
    },
     getExpiryDate(date, duration) {
      return date;
    },

    toggleClinicSelect(val) {
      if (val.dept_code === "XCL") {
        this.hide_clinic_select = false;
        this.afetchClinics();
      }
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.password) {
        this.password = this.editedItem.password;
      }
      this.dialog = true;
    },

    resetPassword(item) {
      // console.log("data resetpassword", item);
      let data = {
        id: item.item.user_id,
        user_name: item.item.username
      };
      // console.log("user selected", data)
      this.selected_user_id = data.id;
      this.selected_user_name = data.user_name;
    },

    deleteItem(item) {
      this.$swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          "Something went wrong. Please contact I.T. on 339 for assistance. \n It looks like you are trying to perform a restricted action!"
      });
      /* const index = this.users.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.users.splice(index, 1); */
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        let data = {
          user_id: this.editedItem.user_id,
          // username: this.editedItem.username,
          // password: this.password,
          firstname: this.editedItem.firstname,
          lastname: this.editedItem.lastname,
          status: this.editedItem.status,
          group_id: this.editedItem.group_id,
          department_id: this.editedItem.dept_id["dept_id"],
          clinic_id: this.editedItem.clinic_id,
          app_id: this.editedItem.app_id
        };

        this.$store.dispatch("users/updateUser", data).then(res => {
          if (res.success) {
            this.initialize();
            this.$noty.success(res.success);
          } else {
            this.$noty.warning(res.error);
            return;
          }
        });
      } else {
        //console.log(this.editedItem)
        let data = {
          username: this.editedItem.username,
          password: this.password,
          firstname: this.editedItem.firstname,
          lastname: this.editedItem.lastname,
          status: 1,
          group_id: this.editedItem.group_id,
          department_id: this.editedItem.dept_id["dept_id"],
          password_expiry_date: this.getExpiryDate(this.current_date, 3),
          clinic_id: this.editedItem.clinic_id,
          app_id: this.editedItem.app_id
        };

        this.$store.dispatch("users/saveUser", data).then(res => {
          if (res.success) {
            this.initialize();
            this.$noty.success(res.success);
          } else {
            this.$noty.warning(res.error);
            return;
          }
        });
      }
      this.close();
    }
  }
};
</script>
